import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function ProjectCard({ project, content, action, featured = false, index }) {
  return (
    <Link
      className={`project-card ${featured ? "project-card-featured" : ""}`}
      to={`/projects/${project.slug}`}
      aria-label={`${action}: ${content.title}`}
    >
      <div className="project-card-media">
        <img src={project.cardImage || project.image} alt="" loading={featured ? "eager" : "lazy"} />
        <span className="project-index">{String(index + 1).padStart(2, "0")}</span>
        <span className="project-card-arrow" aria-hidden="true"><ArrowUpRight size={22} /></span>
      </div>
      <div className="project-card-copy">
        <p className="project-category">{content.category}</p>
        <h3>{content.title}</h3>
        <p>{content.cardTitle}</p>
      </div>
    </Link>
  );
}
